/*
 * This will disable the default script included via Shopify app Script Tags,
 * thereby preventing conflicts with the new code.
 */
// eslint-disable-next-line no-unused-vars, no-implicit-globals
var tagalysDisableLegacyScript = true;

/**
 * Tagalys store configuration
 */
const setTagalysConfiguration = function() {
  window.Tagalys.setConfiguration({
    api: {
      serverUrl: window.theme.tagalysServerUrl,
      credentials: {
        clientCode: window.theme.tagalysClientCode,
        apiKey: window.theme.tagalysApiKey
      },
      storeId: window.theme.storeId
    },
    locale: 'en-US',
    numberFormatter: function (number) {
      number = parseFloat(number)
      if(window.theme.store == "EU") {
        number = number.toFixed(2);
        number = number.toString();
        return number.replace(".",",");
      }else{
        number = number.toFixed(2);
        return number;
      }
    },
    currency: {
      displayFormatter:
        window.theme.currentCurrency === "PLN"
          ? "{{value}} {{currencyLabel}}"
          : "{{currencyLabel}}{{value}}",
      code: window.theme.currentCurrency,
      label: "<sup>" + window.theme.currentCurrencySymbol + "</sup>",
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    analyticsStorageConsentProvided: function() {
      return window.theme.enableTagalysEventsTracking;
    },
    track: window.theme.enableTagalysEventsTracking
  });
};

function setPlatformConfigurationForTagalys() { // eslint-disable-line
  Tagalys.setPlatformConfiguration({
    platform: 'Shopify',
    countryCode: Shopify.country,
    baseCountryCode: window.theme.store === 'EU' ? 'DE' : window.theme.store,
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
    accessToken: window.theme.storefrontAPIToken,
    myShopifyDomain: window.theme.permanent_domain
    },
    metafields: {
      products: [{
        namespace: 'okendo',
        key: 'StarRatingSnippet'
      },
      {
        namespace: 'okendo',
        key: 'summaryData'
      }]
    }
  });
}

function onTagalysReady(callback) { // eslint-disable-line
  if (window.Tagalys) {
    setTagalysConfiguration();
    setPlatformConfigurationForTagalys();
    callback();
  } else {
    window.addEventListener('DOMContentLoaded', function() {
      setTagalysConfiguration();
      setPlatformConfigurationForTagalys();
      callback();
    });
  }
}